/* eslint-disable no-param-reassign */
/* eslint-disable consistent-return */
/* eslint-disable array-callback-return */
import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';

import { GeneralContext } from '../../../core/app-context/GeneralContext';
import { Translator } from '../../../core/i18n/translator';
import { ButtonPrimary } from '../../../shared/components';
import Table from '../../../shared/components/Table';
import TitlePage from '../../../shared/components/TitlePage';
import OrdersFilter from './components/OrdersFilter';
import { useExportOrderCsv } from './hooks/use-export-orders-csv';
import { useGetOrders } from './hooks/use-get-all-orders';
import { HeaderPage, ActionsPage } from './styles';
import { PrivatePageStructure } from '../../../shared/components/PrivatePageStructure';

function OrderList() {
  const navigate = useNavigate();
  const { user, store } = useContext(GeneralContext);
  const userId = user?.id;
  const storeId = store?.id;
  const [formQueryTable, setFormQueryTable] = useState({
    offset: 0,
    limit: 10,
    filters: {
      status: null,
      commerce: null,
      orderCode: null,
      itemQuantity: null,
    },
  });
  const [isExporting, setIsExporting] = useState(false);
  const {
    getOrders,
    orders: dataRows,
    totalOrderQuantity,
  } = useGetOrders({ userId });
  const { exportOrdersCsv } = useExportOrderCsv();

  const columns = [
    { key: 'code', value: 'Codigo da Compra' },
    { key: 'itemCount', value: 'Quantidade' },
    { key: 'orderDate', value: 'Criação em' },
    { key: 'totalValue', value: 'Valor total' },
    { key: 'status', value: 'Status' },
  ];

  const handleToOrderDetails = (order) => {
    navigate(`${order}`);
  };

  const handleFilterOrder = async (formQuery) => {
    setFormQueryTable(formQuery);
    await getOrders({ ...formQuery });
  };

  const handleSetPageOrderList = async (numberPage) => {
    setFormQueryTable({
      ...formQueryTable,
      offset: numberPage,
    });
    await getOrders({
      ...formQueryTable,
      offset: numberPage,
    });
  };

  return (
    <>
      <HeaderPage>
        <TitlePage label={Translator('order.text.title')} />
        <div
          style={{
            justifyContent: 'normal',
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
          }}
        >
          <ButtonPrimary.Normal
            label={Translator('order.buttons.export')}
            width="160px"
            isLoading={isExporting}
            onClick={async () => {
              setIsExporting(true);
              await exportOrdersCsv({
                storeId,
                filters: formQueryTable.filters,
              });
              setIsExporting(false);
            }}
          />
        </div>
      </HeaderPage>
      <ActionsPage>
        <OrdersFilter handleFilterOrder={handleFilterOrder} />
      </ActionsPage>
      <Table
        columns={columns}
        dataRows={dataRows}
        totalOrders={totalOrderQuantity}
        handleSetPageOrderList={async (value) => {
          await handleSetPageOrderList(value);
        }}
        changeRowPerPage={async (numberPage) => {
          setFormQueryTable({
            ...formQueryTable,
            offset: 0,
            limit: numberPage,
          });
          await getOrders({
            ...formQueryTable,
            offset: 0,
            limit: numberPage,
          });
        }}
        onClick={handleToOrderDetails}
      />
    </>
  );
}

export default OrderList;
